import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://herbaliferossano.com";
export const SITE_NAME = "Herbalife Rossano";
export const DEFAULT_OG =
  "https://images.pexels.com/photos/3615219/pexels-photo-3615219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";

export function absUrl(path = "/") {
  if (!path) path = "/";
  if (String(path).startsWith("http")) return path;
  return SITE_URL + (path.startsWith("/") ? path : "/" + path);
}

export function Seo({ title, description, canonical, image, noindex = false, type = "website", jsonLd }) {
  const url = canonical != null ? absUrl(canonical) : undefined;
  const img = image || DEFAULT_OG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet prioritizeSeoTags>
      <html lang="it" />
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      {url ? <link rel="canonical" href={url} /> : null}
      <meta name="robots" content={noindex ? "noindex,follow" : "index,follow"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {url ? <meta property="og:url" content={url} /> : null}
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="it_IT" />
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}

export function breadcrumb(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: absUrl(it.path),
    })),
  };
}
